
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: '교환',
    bba: '통화 계정',
    hy: '계약',
    jg: '옵션 거래',
    jg1: '선물',
    hya: '계약 계정'
  },
  home:{
    user:'사용자의 일반적인 선택',
    start:'거래 시작',
    trading:'무역상품',
    fee:'최소 취급 수수료',
    co:'공동',
    varieties:'품종 거래',
    leading:'web3의 혁신과 탐구를 선도합니다.',
    market:'交무역상품 시장동향',
    explore:'끝없는 가능성을 탐험해보세요',
    newcurrency:'새로운 화폐 구독 기능이 온라인에 추가되었습니다!',
    alimited:'새로운 코인이 온라인에 있습니다. 여기에서 잠재력이 있다고 생각되는 새로운 코인을 구입할 수 있습니다.',
    get_start:'시작하기',
    ai_coin:'AAI 코인 적립 플랜 진행 중',
    ai_text:'AI, 안정적인 수입, 높은 수익률로 누워서도 코인을 벌 수 있는 코인 적립 시작',
    loan:'대출 기능은 온라인입니다',
    loan_text:'돈이 없을 때 대출을 신청하면 당일 바로 발급됩니다.',
    mobile_pc:'手간호사들이 모바일PC로 사용',
    pc_anytime:'언제 어디서나 거래를 시작하세요:',
    pc_text:'우리는 50개 이상의 기술 지표와 디스크 분석 도구 등 강력한 차트 분석 도구를 제공합니다. 안전하고 신뢰할 수 있으며 사용하기 쉬운 레버리지와 높은 레버리지 기능은 온라인 투자의 표준 플랫폼이 되었습니다.',
    mobile_down:'다운로드하려면 클릭하세요',
    mobile_android:'안드로이드 마켓',
    mobile_ios:'사과 가게',
    open_text:'실제 거래 계좌를 신청하거나 3분의 1 비용으로 무료로 데모 계좌를 시험해 볼 수 있습니다.',
    open_account:'계좌',
    tocomplete:'완료하다',
    walletlogin:'지갑 로그인'
  },
  index: {
    h24: '24시간 볼륨',
    header_title: ['디지털 자산 거래 선택 ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'완전한 원 스톱 블록 체인 디지털 자산 거래',
    header_msg: '안전하고 신뢰할 수있는',
    register_title: '등록 ' + window.GLOBAL.LANG_TITLE.zh + ' 글로벌 계정 거래 시작',
    register_pl: '이메일 또는 휴대폰을 입력하세요',
    register: '등록',
    featureTitleWhy: '왜 우리를 선택 했죠',
    featureTitle: '안전 · 안정 · 신뢰성',
    featureMsg: '',
    featureList: [
      {icon : icon1, title : '안전한 지갑 기술', msg : [ '콜드 앤 핫 월렛 기술은 세계 최고의 보안 팀에서 개발했으며 코인 손실 사고는 없었습니다. ','']},
       {icon : icon2, title : '풍부한 암호화 자산 사업', msg : [ '지원 현물 및 여러 파생 상품 거래 등은 암호화 자산 세계에 대한 귀하의 개인 청지기입니다. ','']},
       {icon : icon3, title : '전 세계에 분포 된 고객', msg : [ '전 세계 130 개 이상의 국가 또는 지역에있는 사용자를 위해 당사는 암호화 된 자산 서비스의 전체 범위를 제공합니다. ','']}
    ],
    bannerList: [
      {icon: banner01,title: "업계 최고의 보안 및 안정성 제공에 전념", msg: ["투자자 자산 안전을 보호하기 위한 스마트 계약", "실제 거래 성과", "24시간 서비스 보장"] },
      {icon: banner02,title: "간단한 조작으로 바로 사고팔고 싶다", msg: ["간단한 거래 화면", "계정 잔고에 바로 반영", "대부분의 암호화폐 거래 가능" ] },
      {icon: banner03,title: "결제계약 거래를 통해 적극적으로 수익을 내고 싶습니다.", msg: ["동시에 계좌를 개설하세요", "다수의 거래 선물에 대한 전략적 투자", "24개 거래가 가능합니다. 1년 365일, 주말에도 몇 시간 동안"]}
    ],
    featureList2: [
      {icon: icon1_01, title: "Transparency and Openness", msg: ["블록체인 및 스마트 계약의 특성을 사용하여 체인에서 트랜잭션 성능을 구현하고 스마트 계약을 사용하여 투자자 자산의 안전을 보장",""] },
      {icon: icon1_02, title: "Smart Investment", msg: ["최고의 양적 거래 전문가가 제공하는 다양한 전략으로 자유롭게 선택할 수 있습니다.",""] },
      {icon: icon1_03, title: "Risk grading", msg: ["각 투자자의 다양한 위험 및 자산 관리 선호도에 따라 다양한 투자 상품을 설계하여 투자 임계값을 효과적으로 제거", ""] },
      {icon: icon1_04, title: "Diversified products", msg: ["다양한 유형의 사용자 투자 요구와 유연한 플랫폼 메커니즘을 제공하고 시장보다 나은 혁신적인 금융 서비스를 지속적으로 생산합니다.", ""]}
    ],
    featureTitle2: '언제 어디서나 멀티 플랫폼 터미널 거래',
    featureMsg2: 'iOS 및 Android의 여러 플랫폼을 포괄하며 풀 서비스 기능을 지원합니다.',
    tab: ['주류 통화', '24 시간 상승 표 '],
    thead: ['트레이딩 페어', '최신가', '오늘의 최고가', '오늘의 최저가', '라이징리스트', '24H 볼륨', '오퍼레이션'],
    more: '더보기 >',
    btn: '트랜잭션',
    dealsTitle: '원 스톱 거래 서비스',
    dealsTab:[
      { title: '교환', content: '통화 거래는 다른 통화를 구매하기 위해 USDT를 평가 단위로 사용하는 디지털 자산 간의 교환을위한 것입니다.'+window.GLOBAL.LANG_TITLE.zh+'통화 거래는 Bitcoin, Ethereum 및 Litecoin과 같은 디지털 자산의 실시간 거래를 지원합니다.', src:'/static/image/deals-1.jpg', path: '' },
      { title: '연락처', content: '디지털 통화의 금융 파생 상품은 수익을 얻기 위해 매수 또는 매도 계약을 구매하는 선택을 지원할뿐만 아니라 운영이 간단하고 만료되지 않습니다.'+window.GLOBAL.LANG_TITLE.zh+'계약에는 최대 100 배의 레버리지가있는 고급 위험 관리 시스템이 있습니다.', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['옵션', '계약', '코인'],
    thead: ['통화', '최근 가격', '24 시간 변동 ', '24 시간 최저', '24 시간 최고 ', '24 시간 거래량', '운용'],
    nodata: '데이터가 없습니다'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "회사 소개",
        dd: [{title : "회사 프로필", id : 1}, {title : "지원 센터", type : 'help'}]
      },
      {
        dt: "사용자 지원",
        dd: [
          {title : "사용자 계약", id : 3},
          {title : "개인 정보 보호 정책", ID : 5}
        ]
      },
      {
        dt: "문의하기",
        icon: true
      }
    ],
    terms: "이용약관",
    serve: "제공하다",
    product: "제품",
  },
  nav: {
    btn: ["로그인", "등록", "자산 관리", "앱 다운로드"],
    nav: [
      // { title: "홈", path: "/index",name: 'index' },
      // { title: "교환", path: "/deal",name: 'deal' },
      { title: "시장", path: "/market",name: 'market' },
      { title: "거래", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "교환", path: "/deal", name: 'deal'},
      // { title: "연락처", path: "/deal_c", name: 'deal_c' },
      // { title: "암호화폐", path: "/deal_jg", name: 'deal_jg' },
      // { title: "AI 돈을 얻다", path: "/profit_index",name: 'profit_index' },
      { title: "재테크", path: "/profit_index",name: 'profit_index' },
      { title: "활동", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "내 자산", path: "/asset" }],
    menus: [
      {icon : langzh, title : "사용자 센터", path : "/setting"},
      {icon : langen, title : "로그 아웃"}
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "다운로드"
  },
  // 登录
  // login: {
  //   login: '로그인하세요',
  //   msg: '등록 된 계정을 입력하세요',
  //   list: ['모바일 / 이메일', '비밀번호', '비밀번호 분실', '로그인', '계정 없음, 지금 등록'],
  //   message: '계정 또는 비밀번호는 비워 둘 수 없습니다.'
  // },
  register: {
    dl: ['모바일 등록', '이메일 등록'],
    title: '계정 등록',
    country: '시민권 국가',
    country_info: '등록 후 국적 정보는 수정할 수 없으므로 정직하게 선택 해주세요.',
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    code_no_data: '인증 코드를 입력해야합니다.',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',
    pid_text: '초대 코드',
    pid_pl: '선택 과목',
    invitation_code_no_data: '초대 코드가 필요합니다.',
    xy: '사용자 동의',
    xy_no_checked : '프로토콜을 선택하십시오',
    agree : '나는 읽고 동의했습니다',
    register_btn : '등록',
    bz: ['등록 후 국적 정보는 수정할 수 없으니 정직하게 선택하시기 바랍니다. ','확인 메일은 스팸으로 오인 될 수 있으니주의 깊게 확인하시기 바랍니다. ','계정을 올바르게 유지하십시오 '+ window.GLOBAL.LANG_TITLE.zh +'계정 및 로그인 비밀번호. ','다른 웹 사이트와 동일한 로그인 비밀번호를 사용하지 마십시오. '],
    account_no_data: '계정은 비워 둘 수 없습니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.'
  },
  // 设置密码
  bindmpwd: {
    title: '암호를 설정하세요',
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',
    code_no_data: '인증 코드를 입력해야합니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.',
    bindmpwd_btn: '확인',
    phone_no_data: '전화 번호는 비워 둘 수 없습니다.',
    password_login_text: '로그인 암호를 입력해 주십시오',
    password_trade_text: '암호 길이 6자리',
    password_again_tarde_text: '암호 길이 6자리',
  },
  // 忘记密码
  forgetpwd: {
    title: ['비밀번호 수정', '비밀번호 분실'],
    account: '계좌 번호',
    code_text: '확인 코드',
    code_btn: 'CAPTCHA 받기',
    code_unit: 's',
    password_text: '암호를 입력해 주십시오',
    password_again_text: '암호 다시 입력',

    phone_no_data: '전화 번호는 비워 둘 수 없습니다.',

    account_no_data: '계정은 비워 둘 수 없습니다.',
    code_no_data: '인증 코드를 입력해야합니다.',
    code_no_equality: '확인 코드가 동일하지 않습니다.',
    password_no_data: '비밀번호는 비워 둘 수 없습니다.',
    password_no_equality: '두 암호가 같지 않습니다.',
    forgetpwd_btn: '확인'
  },
  // 绑定手机号码
  bindphone: {
    title: '휴대 전화 번호 바인딩',
    phone_text: '전화 번호',
  },
  person: {
    more: '더 많이 불러오기',
    no_more: '더 이상 데이터 없음',
    index_center:"사용자 센터",
    index_menus: [
      { icon: zhsz, title: "계정 관리", path: '/setting' },
      { icon: sfrz, title: "KYC 인증", path: '/sfyz' },
      { icon: sfrz, title: "주니어 자격증", path: '/smauth' },
      { icon: sfrz, title: "시니어 자격증", path: '/seniorauth' },
      { icon: jtrz, title: "주소 인증", path: '/dzrz' },
      { icon: jtrz, title: "암호화폐 매입", path: '/kjmbSelect' },
      { icon: jtrz, title: "신용 점수", path: '/credit' },
      { icon: jtrz, title: "기록", path: '/deallog' },
      { icon: jtrz, title: "예치 기록", path: '/cbjl' },
      { icon: jtrz, title: "인출 기록", path: '/tbjl' },
    //  { icon: jtrz, title: "我的消息", path: '/news' }
    ],
    cbtb: '예치 및 인출',
    jymx: '거래 상세 정보',
    xyf: {
      'title': '신용 점수',
       'pgsj': '평가 시간'
    },
    smrz:{
       title:'시니어 자격증' ,
       sure_title : '실명 인증 통과',
       zj_type : '인증서 유형',
       zj_info : [ '1, 인증 정보는 일단 확인되면 수정할 수 없습니다. 사실대로 입력 해주세요', '2, 인증 된 실명 정보는 재 인증 불가'],
       zj_name : '이름',
       zj_num : '문서 번호',
       zj_btn : 'OK',
       zj_rebtn : '재 검증',
       zj_sebtn : '고급 검증',
       zj_type_array:[{name:'ID 카드',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "ID 카드"
        },
        {
            id: 2,
            name: "여권"
        },
        {
            id: 3,
            name: "운전면허증"
        },
        {
            id: 4,
            name: "거주 허가"
        },
        {
            id: 5,
            name: "다른"
        }
       ],
       zj_data:{city:'국적은 비워 둘 수 없습니다.',type:'자격 증명 유형은 비워 둘 수 없습니다.',name:'이름은 비워둘 수 없습니다',zj_num:'ID 번호는 비워둘 수 없습니다'},
       zsxm: '실제 이름',
       qsrzsxm: '실제 이름을 입력해 주십시오',
       zjlx: '유효한 신분증(ID) 유형',
       qxzzjlx: 'ID 유형을 선택해 주십시오',
       sfz: 'ID 카드',
       zjhm: 'ID 번호',
       qsrzjhm: 'ID 번호를 입력해 주십시오',
       sczjz: 'ID 사진 업로드',
       zjzm: 'ID 문서의 앞면 사진 업로드',
       zjfm: 'ID 문서의 뒷면 사진 업로드',
       qsczjzm: '신분증 앞면 사진을 업로드 해주세요.',
       qsczjfm: '신분증 뒷면 사진을 업로드 해주세요.',
       scqmz: 'ID 문서 및 개인 서명 업로드',
       qscscqmz: '신분증과 개인 서명 사진을 업로드 해주세요.',
       zj: [
         {
           id: 1,
           title: 'ID 카드'
         },
         {
           id: 2,
           title: '여권'
         },
         {
           id: 3,
           title: '다른'
         },
       ],
       tj: '제출',
       shz: '검토 중',
       shtg: '승인됨'
    },
    gjrz:{
      title:'시니어 자격증',
      zj_info:['1. 8MB보다 작은 크기의 JPG JPEG 또는 PNG 포맷의 이미지들이 지원됩니다.','2. ID 문서 사진은 선명해야 하고 수정되거나 가려져서는 안 됩니다. 개인 사진 문서 번호와 문서 보유자의 이름이 선명하게 드러나야 합니다.','3. 사진은 모자를 쓰지 않은 상태로 촬영되어야 하고 화장을 하지 말 것을 권장합니다. 사진의 안면 기능들이 선명하고 알아볼 수 있어야 하며, 팔이 안전히 노출되어야 합니다.'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'보안 설정',
      bind:[{bind_title : '암호 재설정', bind_name : 'Email'}, {bind_title : '거래 암호 설정', bind_name : 'Email'}]
    },
    wdtg:{
      own_code : '독점 초대 코드',
      own_code_url : '독점 초대 연결',
      own_push_title : '내 프로모션',
      own_push_content : [ '총 초청 수익 (가치)', '초대 수', '사람'],
      own_push_content_profit : [ '레벨 1 초대 혜택', '레벨 2 초대 혜택', '레벨 3 초대 혜택', '레벨 4 초대 혜택'],
      own_push_content_num : [ '1 단계 초대 수', '2 단계 초대 수', '3 단계 초대 수', '4 단계 초대 수'],
      own_push_profit_title : [ 'ID', 'profit', 'remarks information', 'add time'],
      own_push_num_title : [ 'ID', 'name', 'phone', 'add time'],
    },
    jyzt_td : [ '시간', '상세', '금액'],
    cbjl_td : [ '시간', '통화', '수량', '상태'],
    sfrz_txt : [ '본인 인증', '감사를 제출하셨습니다. 결과를 기다려주세요', '고급 인증을 통과했습니다', '신분증 앞', '신분증 뒷면', '인증', ' 인증에 실패했습니다. 다시 인증하십시오. '],

    zhsz_txt : [ '계정 보안 수준 : #', '계정 보안 수준 : #, 추가 정보 개선 및 계정 보안 보장'],
    zhsz_m : 'strong',
    zhsz_n : '약함',
    zhsz_p : '안전하지 않음',
    zhsz_detailList: [
      { icon: '/static/image/User_Center-password.png', title : '로그인 비밀번호', value : '인터넷 계정이 도용 될 위험이 있습니다. 계정 보안을 위해 정기적으로 비밀번호를 변경하는 것이 좋습니다. ', value2 :'', btn : '수정', bind_email : '먼저 이메일 또는 휴대폰을 바인딩하십시오', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title : '거래 비밀번호', value : '비밀번호 설정', btn : '설정으로 이동', path: '/bindmpwd' }
    ],
    sksz_txt : [ '영수증 설정', '저장'],
    sksz_list: [
      { label: "用户名:", pl: "请输入用户名", key: "name" },
      { label: "开户行名称:", pl: "请输入开户行名称", key: "bank_name" },
      { label: "银行卡号:", pl: "请输入银行卡号", key: "bank_number" },
      { label: "支付宝账号:", pl: "请输入支付宝账号", key: "alipay_account" },
      { label: "微信昵称：", pl: "请输入微信昵称", key: "weixin_nickname" },
      { label: "微信账号：", pl: "请输入微信账号", key: "weixin_account" }
    ]
  },
  pasination: {
    first : '집',
    prev : '이전 페이지',
    next : '다음 페이지',
    last : '마지막 페이지',
    no_data: '데이터가 없습니다',
  },
  asset: {
    title: '내 자산',
    zjhz: '자금 이체',
    cb: '예치',
    gz: 'USDT 평가',
    atnv: [],
    zh_title: '전환 된 총 자산：',
    index_title: '자산',
    address_title: '통화',
    address_txt: ['선택하세요', '인출 주소', '내용을 입력하세요', '비고', '주소 목록'],
    address_btn: ['추가', '저장', '삭제', '편집'],
    address_td: ['통화', '인출 주소', '비고', '작업'],
    currency_td: ['통화', '이용 가능', '동결', '전환'],

    table_title: '총 자산：',
    table_address_title: '출금 주소 관리',
    table_td: ['통화', '이용 가능', '동결', '전환', '작업'],
    table_btn: ['예치', '인출', '记录', '이전'],

    money_text: ['인출 주소', '선택하세요', '금액', '이용 가능：', '수수료',
      '도착 금액', '거래 암호','태그 (메모)','최소 '],
    money_btn: '인출',
    xzbz: '통화 선택',
    money_msg: ['미리 알림', '1. 출금 시간은 홍콩 시간 12 : 00-24 : 00, 하루 2 회 출금 신청 (최소 출금 100u, 최대 출금 200,000u)', '2. 현재 출금은 USDT 통화 만 지원되며, 지갑 링크 유형 선택 ERC20; ','3. 출금 신청서 제출 후 출금이 진행 중이기 때문에 자금이 동결되며, 자금은 시스템에 의해 일시적으로 관리되며 귀하가 자유롭게 관리 할 수 ​​없습니다. 자산을 잃어 버렸거나 자산이 비정상적인 것은 아닙니다. 승인을 기다려주세요. ','4. 출금 신청서 제출 후 도착 시간은 블록 확인 시간에 따릅니다. 출금 시간 이후에도 출금이 예상되지 않을 경우 고객 센터로 문의하시기 바랍니다. ',' 5. 현재 행동을 막기 위해 출금을 시작하려면 총 소비량의 90 %가 필요합니다. '],

    recharge_title: '재충전 주소',
    recharge_btn: ['복사', 'QR 코드', '예치'],
    recharge_text: ['금액', '미리 알림', 'USDT가 아닌 자산을 위 주소로 충전하지 마십시오. 그렇지 않으면 자산이 회수되지 않습니다. ','USDT 입금은 단순 송금 방식 만 지원하며, 다른 방식으로 입금 (모두 보내기)은 일시적으로 게시 할 수 없으므로 양해 바랍니다. ','신임장', '바우처 설명(선택 과목)','체인 이름'],

    record_title: '재무 기록',
    record_td: ['금액', '녹음', '시간'],

    transfer_title: '이전',
    transfer_btn: ['모두', '전송'],
    transfer_text: ['에서', '...에', '이체 금액을 입력하세요', '이용 가능：'],
    "bq": "태그 (메모)",
    "qsrbq": "태그를 입력해 주십시오",
    "yhktx": "은행 카드 인출",
    "yhmc": "은행 이름",
    "qsryhmc": "은행 이름을 입력해 주십시오",
    "yhzh": "은행 계좌",
    "qsryhzh": "은행 계좌를 입력해 주십시오",
    "gjhkdm": "SWIFT 코드",
    "qsrgjhkdm": "SWIFT 코드를 입력해 주십시오",
    "yhdz": "은행 주소",
    "qsryhdz": "은행 주소를 입력해 주십시오",
    "skrxm": "수취인 이름",
    "qsrskrxm": "수취인 이름을 입력해 주십시오",
    "skrdh": "수취인 전화",
    "qsrskrdh": "수취인 전화를 입력해 주십시오",
    "skrdz": "수취인 주소",
    "qsrskrdz": "수취인 주소를 입력해 주십시오"
  },
  text: {
    btn : '반환',
    login : '먼저 로그인하십시오'
  },
  deal: {
    chooseType: '커미션 유형',
    choose: '선택하세요',
    balance: '잔고：',
    account: ['계정', '사용 가능', '/ Freeze', 'Transfer'],
    dir: ['매입', '매도'],
    dir2: ['이용 가능', '판매 가능'],
    cs: '선택 사항',
    sxf: '수수료율',
    jye: '회전율',
    sc_list: ['시장', '동전 쌍', '가격 상승'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt : [ '통화', '최신 가격', '상승 가격'],
    k_line_txt : [ '≈', '', '증가', '최고가', '최저가', '24 시간 볼륨 '],
    tabListLTitle: ["대기 주문", "커미션 이력"],
    tabListLEntrust: ["매입", "매도"],
    tabListRTitle: ["거래 제한", "시장 거래"],
    table_btn: ['주문 취소'],
    index_td_l: ['시간', '거래 대상', '수량', '가격', '운영'],
    index_td_r: ['최근 가격', '방향', '가격', '수량'],
    index_td_r2: ['최근 거래', '시간', '가격', '거래량'],
    table_txt: ['완료됨', '주문 취소됨'],
    db_1_txt: ['유효한', '구매 가격', '판매 가격', '바이 인', '판매량', '거래 금액', '시장에서 가장 좋은 가격에 구매', '시장에서 최고의 가격으로 판매', '손 구매', '손 판매'],
    db_2_txt: ['가격', '지렛대', '선택하세요', '제비', '1로트 =', '로트', '계약 시장 가치', '여유', '시장에서 가장 좋은 가격에 구매', '시장에서 최고의 가격으로 판매'],
    pathList : [ '계약 기록', '거래 기록'],
    db_btn: ['구매 (매수)', '매도 (숏)'],
    tabListLTitle2: ['대기 주문'],

    lt_btn: ['원클릭 환금', '손절매 및 손절매 가격 설정', '클로즈', '지금 제출', '반환'],
    lt_txt: ['위험률 :', '총 수익'],
    lt_td : [ 'Type', 'Leverage Multiple', 'Position Price', 'Current Price', 'Margin', 'Take Profit Price', 'Stop Loss Price', 'Open Time', 'Number of Lots', ' 손익 ','Operation '],
     lt_dl : [ '손절매 및 손절매 가격 설정', 'Stop Profit Price', 'Stop Loss Price'],

    lt_0_btn: ['주문 취소'],
    lt_0_td: ['연락처', '통화', '수량', '현재 가격', '취급 수수료', '운용'],

    lt_1_btn: ['클로즈'],
    lt_1_txt: ['청산'],
    lt_1_td: ['유형', '포지션 가격', '현재 가격', '마진', '수익 가격', '손절매 가격', '개장 시간', '취급 수수료', '손익', '운영'],
    node_data: '데이터가 없습니다',

    lt_3_txt: ['청산됨', '변제'],
    lt_3_td: ['유형', '제비', '포지션 가격', '종가', '수익 가격 취하기', '손실 중단 가격', '본드', '이용 가능 마진', '개시 시간', '청산 시간', '수수료',
      '수익 및 손실', '작업'],

    lt_4_txt: ['주문 취소됨'],
    cm: ['배포 시간', '발행 번호', '流通总量', '总凑价格', '공식 웹사이트','백서','介绍'],
    qsrsl: '금액을 입력해 주십시오',
    qsrss: '로트를 입력하세요',
  },
  notice:{
      notice_title:'발표 센터',
  },
  bzhl:{
    title: 'AI 돈을 얻다',
    title1: 'AI량화',
    ttzbt: '天天赚不停',
    wdtg: '내 호스팅',
    zztgdzj: '보호 예수 자금',
    yjjrsy: '매일 추정',
    ljsy: '총 수입',
    tgzdd: '보호 예수 주문',
    tgdd: '에스크로 주문',
    t1: '위험이 적고 안정적인 재무 관리, 필요한 경우 언제든지 상환 가능',
    t2: '무료 자금 관리 도우미',
    cljxcp: '상품 주기',
    dbxe: '단일 한도',
    rsyl: '일일 수익률(%)',
    rsyl2: '일일 수익률：',
    zq: '주기',
    qmr: '구매하기',
    ckgd: 'xem thêm',
    cpgk: '제품 개요',
    pxsj: '배당금 지급 시기',
    tgzj: '보호 예수 자본',
    tqsh: '조기 상환',
    cpld: '상품 하이라이트',
    cpgz: '제품 규칙',
    cont: '브릭 이동은 플랫폼에서 USDT를 호스팅하는 것이며, 플랫폼의 전문 팀은 브릭을 이동할 권리가 있습니다. 참가자는 언제든지 액세스 할 수있는 펀드 보관 기간 동안 브릭 이동 수입에서 플랫폼의 몫을 얻을 수 있습니다. 안전하고 편리합니다.',
    zj: '100% 펀딩',
    aqbz: '보안',
    jjrsy: '공휴일 수입',
    bjd: '무중단',
    cgcrh: '성공적인 예치 후',
    dtqx: '오늘의 이자 가치',
    ljzr: '지금 전송',
    xqglgj: '무료 자금 관리 도구',
    ddh: '주문 번호',
    tgje: '보호 예수 금액',
    tgsj: '주기 일',
    yhl: '수익:',
    xdsj: '주문 시간',
    zt: '상태',
    fh: '반환',
    qrnhsy: '七日年化收益',
    ygy: '1个月',
    bn: '半年',
    yn: '1年',
    yuan: '元',
    tzfx: '투자 위험',
    shsc: '교환 시간',
    di: '로우',
    yggzr: '1 일',
    msgsxf: '무료 구독료',
    mr: '매일',
    dqfh: '기한 만료 시 반환',
    ljgm: '지금 매입',
    tgz: '보호 예수 중',
    sh: '상환',
    ywc: '완료됨',
    ysh: '상환됨',
    all: '전체',
    "xzbzts": "간단하고 안전합니다. 배당금은 여러 통화로 선택할 수 있습니다.",
    "qtbz": "기타 동전"
  },
  pay:{
    qsrjymm: '6 자리 거래 비밀번호를 입력하세요',
    tbmmts: '거래 비밀번호를 설정하려면 사용자 센터로 이동하세요.',
  },
  tips:{
    qxztbdz: '인출 주소를 입력해 주십시오',
    qsrtbsl: '인출 통화의 수량을 입력해 주십시오'
  },
  statusText: ['실패', '처리 대기 중', '성공'],
  dzrz: {
    title : '주소 인증',
    sdddz : '유틸리티 청구서 주소',
    zdtpsc : '빌 사진 업로드',
    qsrsdddz : '주소 정보를 입력하고 공과금 청구서 또는 광대역 주소 청구서를 제출해야합니다.',
    qsczdtp : '청구서 사진을 올려주세요',
    status : [ '검토 중', '검토 통과'],
    qd : 'OK',
  },
  jgcc: {
    wtgd: '보류 중 주문',
    cj: '딜',
    jj: '정보',
    zc: '현재',
    lszc: '이력',
    qblx: '모든 유형',
    xj: '현재 가격',
    sj: '시간',
    fx: '방향',
    jg: '가격',
    sl: '금액',
    jgsj: '배송 시간',
    gmj: '구매가',
    jsj: '정산가',
    yk: '수익 및 손실',
    xq: '상세 정보',
    "mz": "강세",
    "md": "약세",
    dqye: '현재 잔고',
    gb: '클로즈',
    jxxd: '계속 주문',
    qrxd: '확인',
    ddqr: '주문 확인',
    sxf: '수수료',
    kyye: '균형',
    jypz: '쌍',
    jyfx: '방향',
    tzje: '투자 가격',
    tzjeTips: '투자 금액은 0 일 수 없습니다.',
    dqsj: '만료 시간',
    jssj: '배송 시간',
    gmsj: '구매 시간',
    sy: '수익',
    zxje: '최소 금액 ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: '최대 금액 ',
    qsrje: '금액을 입력하세요',
    zxtzje: '최소 수량 ',
    yebz: '잔액 불충분',
    xq: '상세 정보',
    ddz: '기다리는',
    jgjl: '납품 실적',
    bz: '통화',
    cz: '작업'
  },
  kjmb: {
    title: '암호화폐 매입',
    fzcg: '성공적으로 복사',
    ljmb: '암호화폐 매입',
    lxkf: '고객 서비스에 문의'
  },
  news: {
    title: '내 메시지',
    "gg": "알림",
    ckxq: '상세 정보 보기'
  },
  statusTabs:['주문 보류', '거래','청산됨', '인출됨'],
  "chongzhi":{
    "zy": "중요한",
    "cbxx": "토큰 예치 정보",
    "qrsl": "입금 금액을 입력하십시오",
    "tips2": "1. 지갑/플랫폼 호환성: 즉, 네트워크가 지원되며 대상 플랫폼이 출금 네트워크를 지원하지 않는 경우 자산을 검색할 수 없습니다.",
    "tips3": "2. 귀하의 탑업 네트워크와 대상 플랫폼이 동일하며, 대상 주소를 이더리움 네트워크로 선택했지만 탑업이 TRC20 스마트체인을 선택한 경우 디지털 자산을 검색하지 못할 수 있습니다.",
    "tips4": "3. 충전하기 전에 주소와 금액이 정확한지 확인하십시오.",
    "tips5": "알림: 블록 네트워크의 익명성과 개인 정보 보호로 인해 잘못된 정보를 입력하면 해당 자산을 잃게 됩니다. 충전 주소와 수량을 잘 확인하세요.",
    "tip2_1": "• 위 주소로 현지 통화가 아닌 자산을 청구하지 마십시오. 그렇지 않으면 자산을 검색할 수 없습니다.",
    "tip2_2": "• 디지털 화폐는 제시간에 배송될 수 없습니다. 실제 도착 시간은 블록체인의 확인 속도에 따라 다릅니다.",
    "tip2_3": "• 충전 주소는 자주 변경되지 않으며 충전할 수 있습니다. 변경 사항이 있는 경우 웹사이트 공지 또는 이메일을 통해 알려 드리겠습니다.",
  },
  "tibi":{
    "tbxx": "출금 정보",
    "qsrbq": "레이블을 입력하십시오",
    "tbTips1": "• 자금의 안전을 위해 계정 보안 정책이 변경되거나 비밀번호가 변경될 경우 수동으로 출금을 검토하므로 직원이 전화 또는 이메일로 연락을 드릴 때까지 참을성 있게 기다려 주십시오.",
    "tbTips2": "• 정보가 변조되거나 유출되지 않도록 컴퓨터와 브라우저가 안전한지 확인하세요.",
    "tbTips3": "• 귀하가 언급한 디지털 자산은 원코인 멀티체인 자산입니다. 어떤 체인에서 모으기를 선택하든, 이는 귀하가 소유한 출금 페이지에 표시되는 디지털 자산의 총량이 감소한다는 것을 의미합니다 해당 금액만큼.",
  },
  "gjlb": "목록 국가 목록",
  "qxzgjlb": "국가 / 지역을 선택하십시오",
  "mbwt":{
    "title": "보안 문제 설정",
    "mbwt": "보안 문제들",
    "problem":[
      {
        "id": 1,
        "title": "어렸을 때 가장 친했던 친구는?"
      },
      {
        "id": 2,
        "title": "당신의 우상은 누구입니까?"
      },
      {
        "id": 3,
        "title": "가장 그리운 곳은 어디인가요?"
      }
    ],
    "qtxda": "답변을 작성해주세요",
    "qsrxmm": "새 비밀번호를 입력하세요",
    "qqrmm": "암호를 확인해 주십시오",
    "sydqmmcz": "현재 비밀번호 재설정 사용",
    "zhmm": "보안 문제 비밀번호 검색",
    "ysz": "설정되었습니다",
    "tg": "뛰어 넘다",
    "tj": "제출하다",
    "zyts": "중요한:",
    "zytsCont": "비밀번호와 인증번호를 공개하지 마시고, 비밀번호 찾기에 도움이 되는 보안 문제를 염두에 두시기 바랍니다."
  },
  "zc":{
    "zclb": "자산 목록",
    "zczh": "자산 전환",
    "yczc": "보유하고 있지 않은 자산 숨기기"
  },
  "indexNew":{
    "t1": "글로벌 리딩",
    "t2": "디지털 자산 서비스 플랫폼",
    "t3": "원스톱 블록체인 디지털 자산 거래 완료",
    "t4": "휴대폰 번호/이메일",
    "t5": "지금 등록",
    "t6": "FXSFC을 통해 전 세계 고객을 환영합니다",
    "t7":"암호화 여정을 발견하고 시작하세요"
  },
  "newReg":{
    "dl": ['이메일','휴대전화'],
    "cjzh": "계정 만들기",
    "sysjhzyx": "휴대폰 번호/이메일로 등록",
    "yhxy": "&lt;이용약관&gt;",
    "yhxy2": "및 &lt;이용약관&gt;을 읽었으며 이에 동의합니다.",
    "yxgz": "유효한 이메일을 입력하십시오",
    "dhgz": "휴대폰 번호가 잘못되었습니다"
  },
  "indexNew2":{
    "t1": "주문에 따라 거래",
    "t2": "비트뱅크 사용",
    "t3": "Bitbank는 독창적으로 설계된 비트코인 ​​및 암호화된 자산 거래소입니다. 매우 간단하고 편리하며 안전하고 강력합니다. 여러 웹 및 스마트폰 플랫폼에서 거래를 지원합니다. 거래 데이터와 차트는 실시간으로 업데이트됩니다. 종합 시장 가격 분석은 60개 이상의 기술적 분석 도구를 제공합니다. 거래 시작",
    "ksjy": "거래 시작",
    "ly": "비트뱅크를 선택해야 하는 5가지 이유",
    "item1_t1": "주요 거래량",
    "item1_t2": "No.1 * 암호화 자산 거래량",
    "item1_t3": "높은 유동성, 편안한(즐거운 거래 경험) 거래. 12가지 유형의 암호화 자산을 나열하십시오.",
    "item2_t1": "높은 타사 평가",
    "item2_t2": "안전한 거래 환경",
    "item2_t3": "오프라인 콜드 월렛을 사용하십시오. Multisig를 사용하여 해커를 차단하십시오. 첨단 기술로 자산을 보호하십시오",
    "item3_t1": "사용하기 쉽고 안정적인 응용 프로그램",
    "item3_t2": "사용하기 쉽고 간단한 응용 프로그램",
    "item3_t3": "풍부한 기능을 갖춘 안정적인 응용 프로그램입니다. 트랜잭션 외부에서 거래 기회를 유지할 수 있습니다.",
    "item4_t1": "하루 종일 영업",
    "item4_t2": "금을 입금할 수 있음",
    "item4_t3": "공휴일 포함 24시간 입금 지원!",
    "item5_t1": "스마트폰 및 PC",
    "item5_t2": "인간화된 디자인",
    "item5_t3": "스마트폰을 이용해도 망설임 없이 간편하고 적격한 거래를 할 수 있다",
    "aqkk": "안전하고 신뢰할 수 있음",
    "aqkk2": "비트뱅크 비트코인 ​​거래",
    "cjzh": "계정 만들기",
  },
  "xbsg":{
    "title": "뉴코인존",
    "wdsg": "세부",
    "scts": "락업일: ",
    "sy": "남은",
    "ljsg": "지금 구독",
    "ysk": "매진",
    "xzjdy": "지금 구독",
    "dy": "구독하다",
    "fxjg": "발행 가격",
    "fxl": "순환",
    "ssrq": "상장일",
    "yxqx": "유효 기간",
    "qsrsl": "수량을 입력해주세요",
    "syl": "남은",
    "sgrq": "구독 날짜",
    "sgsl": "양",
    "bz": "동전",
    "yebz": "USDT 잔액 부족",
    "tgsl": "패스 수량",
    "shz": "검토 중",
    "wtg": "실패",
    "ytg": "통과"
  },
  "wydb":{
    "title": "빌리다",
    "db": "빌리다",
    "dbz": "빌리다",
    "jl": "기록",
    "jdzq": "기간(일)",
    "qhk": "갚다",
    "ljdb": "누적(usdt)",
    "dhkbs" :"지불 보류",
    "jkje": "대출금액(usdt)",
    "qsrje": "수량을 입력해주세요",
    "rll": "일일 이자율",
    "hkfs": "반환",
    "dqych": "만료됨",
    "lx": "관심",
    "fkjg": "대주",
    "tpsc": "신용대출(이미지 업로드)",
    "fwxx": "주택정보",
    "srzm": "소득 증명(고용 관계)",
    "yhmx": "은행 명세서",
    "zjz": "신분증 사진",
    "yd": "읽고 동의했습니다",
    "xy": "대출 계약 신청",
    "sqdb": "대출 체인 신청",
    "gb": "폐쇄",
    "qd": "확인",
    "ts": "대출 계약 신청을 확인하십시오",
    "dbjl": "기록",
    "hkhth": "주문 코드",
    "wsh": "미검토",
    "yfk": "대출",
    "sqrq": "신청 시간",
    "zq": "주기",
    "dbsl": "갈비뼈의 수",
    "zhke": "총 지불",
    "yhkxq": "상환내역",
    "bqyhk": "현재 기간에 상환 가능(USDT)",
    "hktips": "잔액이 충분한지 확인하시고, 잔액이 부족할 경우 충전 후 상환하시기 바랍니다.",
    "bj": "주요한",
    "jie": "빌리다",
    "ljhk": "즉시 상환",
    "qcz": "입금하기",
    "yebzqxcz": "잔액이 부족합니다. 먼저 충전한 다음 상환하세요.",
    "znj": "연체료",
    "yqts": "연체일수"
  },
  "hkxq":{
    "dd":"주문하다",
    "fzhkdz":"상환 주소 복사",
    "hkxq": "상환내역",
    "zlx": "총 이자",
    "zhk": "총 상환액",
    "hkjg": "상환 기관",
    "qschkpz": "상환 증명서를 업로드하십시오",
    "hkpz": "상환 증명서"
  },
  "bbjyNew":{
    "jylx": "유형",
    "jyze": "양"
  },
  "bind":{
    "title": "우편",
    "ybd": "경계",
    "wbd": "매여 있지 않은",
    "ts": "계정을 보호하려면 이메일 주소를 묶는 것이 좋습니다.",
    "qsryxdz": "이메일 주소를 입력해 주십시오"
  },
  "tipsNew": {
    "yjj": "거부",
    "shz": "구원"
  },
  "newIndex2":{
    "zxhy": "최신 인용구",
    "jypt": "거래 플랫폼",
    "ssyc": "숨기기 축소",
    "hwzc": "아직 등록되지 않았습니까?",
    "ljzc": "지금 가입하고 수많은 기회를 발견하세요!",
    "yyzh": "이미 계정이 있습니까?",
    "hjbj": "계정이 있으면 로그인하세요. 오랜만입니다!",
    "lmdh": "열 탐색",
    "ghdjy": "더 나은 거래, 더 나은 삶",
    "ghdjy02": "세계에서 가장 혁신적인 암호 화폐 거래 허브가 여기 있습니다. 여기에서 수백 개의 암호 화폐로 암호 화폐를 사고, 거래하고, 얻을 수 있습니다.",
    "indexCont01": "항상 당신 옆에",
    "indexCont02": "고급 자금 조달 옵션, 번개처럼 빠른 실행 및 풍부한 유동성으로 현물 및 마진 시장을 거래하십시오.",
    "indexCont03": "강력한 API",
    "indexCont04": "직관적인 API, 거래 플랫폼 및 고급 주문 옵션으로 포지션을 손쉽게 관리하세요.",
    "indexCont05": "고품질 디지털 자산",
    "indexCont06": "9년 동안 0건의 사고",
    "indexCont07": "최고 보안 위험 제어",
    "indexCont08": "최대 25배까지 활용",
    "indexCont09": "최대 25배 레버리지로 Bitcoin CFD를 거래하십시오.",
    "indexCont010": "안전 보호 조치",
    "indexCont011": "깊은 유동성",
    "indexCont012": "우리의 고급 독점 다중 시장 주문 장부 기술은 유동성을 향상시키고 스프레드를 강화하며 미끄러짐을 줄입니다.",
    "indexCont013": "사용자 기본 설정",
    "indexCont014": "해당 국가",
    "indexCont015": "우리의 강점",
    "indexCont016": "고급 자금 조달 옵션, 번개처럼 빠른 실행 및 풍부한 유동성으로 현물 및 마진 시장을 거래하십시오.",
    "indexCont017": "안전한 저장소",
    "indexCont018": "저희는 콜드 월렛과 MPC(다자간 컴퓨팅) 기술을 결합하여 디지털 자산을 관리합니다.",
    "indexCont019": "안전 제일",
    "indexCont020": "최신 기술을 사용하여 자금을 안전하게 보호하고 버그 및 악용 시도보다 앞서 있습니다.",
    "indexCont021": "빠른 철수",
    "indexCont022": "다자간 계산을 사용하여 우리의 엄격한 보안 표준을 유지하면서 연중무휴 빠른 출금을 제공할 수 있습니다.",
    "indexCont023": "암호화폐 구매, 판매",
    "indexCont024": "세계에서 가장 포괄적이고 안전한 거래 플랫폼에 참여하세요",
    "indexCont025": "화폐 또는 암호 화폐를 사용하여 Bitcoin, Ethereum, XRP 및 기타 여러 암호 화폐를 사고 팔 수 있습니다.",
    "yqwj": "천만 이상",
    "dlzc": "등록하려면 로그인하십시오",
    "yzm": "인증 코드",
    "qrmm": "비밀번호 확인"
  },
  "langNew2":{
    "flzq": "보상 허브",
    "qdjl": "로그인 보상",
    "mrqdjl": "일일 로그인 보상",
    "qd": "로그인",
    "yqd": "로그인",
    "hdgz": "이벤트 규칙",
    "qdjl2": "체크인 기록",
    "qdcg": "성공적으로 로그인",
    "yhd": "획득",
    "lq": "수신",
    "dyt": "1일차",
    "det": "2일차",
    "dst": "3일차",
    "dsit": "4일차",
    "dwt": "5일차",
    "dlt": "6일차",
    "dqt": "7일차",
    "jxz": "진행 중",
    "cjxnzh": "가상 계정 만들기",
    "sy":"홈페이지",
    "sc":"시장",
    "sclb":"시장 목록",
    "jy":"거래",
    "zh":"계정",
    "db":"대출",
    "zchm":"등록 번호",
    "cp":"제품",
    "tzjd":"투자대출",
    "zxzc":"온라인 지원",
    "xd":"주문하다",
    "zzjptgmnr":"미래에 투자하세요.공정하고 개방적인 금융 시스템에서 포트폴리오를 성장시키세요.",
    "yy":"앱",
    "pqnr":"기존의 틀에서 벗어나 정밀한 재무관리 도구를 제공하는 모바일뱅킹입니다.",
    "jiami":"암호화폐",
    "tgnr":"암호화폐를 사용하여 입금하면 추가 보안 계층을 확보하고 빠른 거래 처리를 보장할 수 있습니다.",
    "jyl":"24시간 거래량",
    "ssjmhb":"암호화폐 목록",
    "zchy":"등록 된 사용자들",
    "djxz":"다운로드하려면 클릭하세요",
    "azsc":"안드로이드 마켓",
    "pgsd":"애플 스토어",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "암호화폐",
  //   "gjs": "금속",
  //   "yy": "조잡한",
  //   "jy": "거래",
  //   "jmhb": "암호화폐",
  //   "yxhy": "영구 계약",
  //   "gdjy": "미결 주문",
  //   "khh": "계좌 개설",
  //   "qsrkhh": "은행에 들어가주세요",
  //   "yhkh": "은행 계좌",
  //   "qsryhkh": "은행 계좌 번호를 입력해 주십시오",
  //  },
   "login":{
     login: '로그인하세요',
     msg: '등록 된 계정을 입력하세요',
     list: ['모바일 / 이메일', '비밀번호', '비밀번호 분실', '로그인', '계정 없음, 지금 등록'],
     message: '계정 또는 비밀번호는 비워 둘 수 없습니다.',
     "cdlks":"로그인부터 시작해볼까요!",
     "zh":"계정",
     "qsrzh":"사용자 이름을 입력하세요",
     "mm":"비밀번호",
     "qsrmm":"암호를 입력",
     "dl":"로그인",
     "wjmm":"비밀번호를 잊으 셨나요",
     "qbdl":"지갑으로 로그인",
     "myzh":"나는 계정이 없나요?",
     "zc":"가입하기",
     "yzm":"확인 코드",
     "qsryzm":"인증코드를 입력하세요",
     "hqyzm":"코드 전송됨",
     "qrmm":"비밀번호 확인",
     "qsrqrmm":"비밀번호 확인",
     "lcmmbyz":"두 개의 비밀번호 입력이 일치하지 않습니다",
     "mmts":"비밀번호 길이는 6~12자",
     "sjtx":"전화번호 형식 오류",
     "yxts":"이메일 형식 오류",
     "qr":"좋아요",
     "sjzc":"이동하는",
     "sjh":"전화 번호",
     "qsrsjh":"전화번호를 입력하세요",
     "yqm":"초대 코드(선택사항)",
     "qsryqm":"초대코드를 입력하세요",
     "yxzc":"이메일",
     "wyydbzx":"동의하다",
     "yhxy":"<사용자 서비스 계약>",
     "yhxy2":"사용자 서비스 계약",
     "ysyx":"<개인 정보 보호 계약>",
     "yx":"이메일",
     "qsryx":"이메일을 입력하세요",
     "yxgsbzc":"잘못된 이메일",
     "cjmnzhcg":"데모 계정이 성공적으로 생성되었습니다",
     "tcmnzh":"데모 계정 종료",
     "qbdlts":"DAPP 지갑을 이용해 주세요. 로그인",
   },
  //  "index":{
  //    "xgnysx":"새로운 기능이 온라인에 추가되었습니다!",
  //    "hyld":"수상 경력에 빛나는 금융 거래 플랫폼에 오신 것을 환영하며 글로벌 투자자와 함께 미래 금융 세계를 탐험해 보세요.",
  //    "symncz":"데모 계정 사용",
  //    "zdjyfy":"최소 거래 수수료 <0.3%",
  //    "jysyzc":"모든 자산을 한 곳에서 거래하세요",
  //    "hbsp":"외환, 암호화폐, 주식, 지수, 상품",
  //    "ksjy":"시작",
  //    "jdewd":"간단하고 안정적",
  //    "aizb":"골든 AI 트레이딩",
  //    "srjh":"한 번의 클릭으로 소득 계획을 세우세요",
  //    "kssy":"사용 시작",
  //    "dlyhggdje":"낮은 금리와 높은 금액",
  //    "jmhbdk":"암호화폐 대출",
  //    "zmyrhdyp":"담보 없이 암호화폐 현물 대출",
  //    "gs":"회사",
  //    "gywm":"회사 소개",
  //    "xkzjd":"라이센스 감독",
  //    "bzzx":"지원 센터",
  //    "zhengce":"정책",
  //    "tkytj":"이용약관",
  //    "yszc":"개인 정보 정책",
  //    "sm":"성명",
  //    "flxx":"법률 정보",
  //    "mzsm":"부인 성명",
  //    "fxjg":"위험 경고",
  //    "gygg":"광고에 대하여",
  //    "gg":"발표",
  //  },
   "hq":{
     "wh":"외환",
     "szhb":"암호화폐",
     "gp":"재고",
     "zs":"색인",
     "eft":"ETF",
     "mc":"이름",
     "xs":"24시간%",
     "tb":"차트",
     "jg":"가격",
   },
   "user":{
     "wdzh":"내 계정",
     "zh":"계정: ",
     "dk":"대출: ",
     "sydbzj":"사용된 마진: ",
     "yqll":"예상 이익: ",
     "qtgn":"기타 기능",
     "cz":"보증금",
     "tx":"철회하다",
     "dh":"교환",
     "zhyz":"KYC 인증",
     "zhjl":"계정 내역",
     "yqhy":"친구를 초대",
     "flzq":"복지존",
     "ggmm":"비밀번호 변경",
     "sz":"설정",
     "cjwtjd":"자주하는 질문",
     "fzdz":"주소 복사",
     "sl":"수량...",
     "qsrsl":"수량 입력",
     "dd":"(USDT) 받기: ",
     "sczm":"바우처 업로드",
     "qsczm":"바우처를 업로드해주세요.",
     "tj":"제출하다",
     "czjl":"입금기록",
     "ddh":"아니요.",
     "wsh":"검토되지 않음",
     "ywc":"완전한",
     "bz":"이름: ",
     "sl2":"수량: ",
     "sj":"시간: ",
     "srsl":"수량을 입력하세요...",
     "dd2":"얻다: ",
     "qskgzflhd":"복지 활동에 항상 관심을 가져주세요. 수시로 공개하겠습니다.",
     "hdlb":"이벤트 목록",
     "ckxq":"세부 정보보기",
     "wdjl":"나의 보상",
     "yiji":"레벨 1",
     "erji":"2 단계",
     "sanji":"레벨 3",
     "je":"양",
     "sj2":"시간",
     "yyxz":"언어",
     "tcdl":"로그아웃",
     "je2":"금액(USD)...",
     "qsrje":"금액을 입력하세요",
     "jsdz":"받는 주소...",
     "qsrjsdz":"수신 주소를 입력하세요",
     "sjdz":"실제 도착: ",
     "sxf":"요금: ",
     "txsm1":"인출에는 5%의 수수료가 필요하며, 이는 입금되기 전에 네트워크 노드에서 확인해야 합니다.",
     "txsm2":"암호화폐를 낯선 사람에게 양도하지 마세요.",
     "tz":"알림",
     "wdyq":"내 초대장",
     "yhid":"UID",
     "hdjl":"USD 보상 받기",
     "yqsm":"친구를 초대하여 Ai 정량화, 채굴기 임대, 상품 거래에 참여하고 암호화폐 보상을 받으세요.",
     "yqsy":"초청소득",
     "yqrs":"초대된 사람의 수",
     "tgljyq":"링크를 통해 초대",
     "lj":"링크",
     "yqm":"초대 코드",
     "cbtb":"입출금",
     "jymx":"상세 거래 내역",
     "yqhyjl":"친구 초대 보상",
     "aidd":"골든 AI 거래 주문",
     "jdls":"대출 내역",
     "etfdd":"ETF 주문",
     "jmhbdd":"암호화폐 주문",
     "whdd":"외환 주문",
     "gpdd":"재고 주문",
     "qx":"취소",
     "zc":"자산",
     "zzc":"총 자산",
     "ky":"사용 가능",
     "zh2":"변환됨(USDT)",
     "xzbz":"선택하다: ",
     "sztkts":"중요: 거래 비밀번호를 설정하려면 보안 센터로 이동하세요.",
     "jymm":"거래 비밀번호",
     "szjymm":"거래 비밀번호 설정",
     "qsrjymm":"거래 비밀번호",
     "zdsl":"최소 수량",
     "bq":"태그(메모)",
     "qsrbq":"태그 입력",
     "yhktx":"은행 송금",
     "yhmc":"은행 이름",
     "qsryhmc":"은행명을 입력하세요",
     "yhzh":"은행 계좌",
     "qsryhzh":"은행계좌번호를 입력하세요",
     "gjhkdm":"스위프트 코드",
     "qsrgjhkdm":"SWIFT 코드를 입력하세요",
     "yhdz":"계좌 번호",
     "qsryhdz":"은행 주소를 입력하세요",
     "skrxm":"수취인 이름",
     "qsrskrxm":"수취인 이름을 입력하세요",
     "skrdh":"수취인 전화번호",
     "qsrskrdh":"수취인의 전화번호를 입력하세요.",
     "skrdz":"수취인 주소",
     "qsrskrdz":"수취인 주소를 입력하세요",
     "tbjl":"출금기록",
     "fzcg":"성공적으로 복사되었습니다",
     "aqzx":"보안센터",
     "yxrz":"이메일 인증",
     "ybd":"경계",
     "wbd":"구속되지 않음",
     "yrz":"확인됨",
     "wrz":"인증되지 않음",
     "ts":"귀하의 계정을 보호하려면 이메일 주소를 바인딩하는 것이 좋습니다",
     "qsryxdz":"이메일을 입력하세요",
     "dlmm":"로그인 비밀번호",
     "mbwtsz":"보안 문제 설정",
     "mbwt":"보안 문제",
     "qtxda":"답변을 작성해 주세요.",
     "zyts":"중요한: ",
     "zytsCont":"보안답변과 인증코드를 공개하지 마시고, 보안질문을 기억해두시면 비밀번호를 복구하는데 도움이 됩니다.",
     "qsrxmm":"새 비밀번호를 입력하세요",
     "sydqmmcz":"현재 비밀번호로 재설정",
     "zhmm":"비밀번호 검색에 대한 보안 문제",
     "ysz":"설정되었습니다",
     "tg":"무시하다",
     "qsrdlmm":"비밀번호를 입력하세요",
     "bzxz":"선택하다: ",
     "zwsj":"데이터 없음",
     "qd":"좋아요",
     "zsgd":"자세히보기",
     "zdss":"최소 로트 크기",
     "mnjy":"모의거래",
     "sx":"필터링",
   },
   "zb":{
     "tgdd":"AI 관리 주문",
     "tgz":"구금 중",
     "ysh":"상환됨",
     "shz":"상환",
     "zq":"주기: ",
     "tian":"낮",
     "syl2":"수익률: ",
     "rgjg":"구독 가격: ",
     "rgjg2":"구독 가격",
     "xdsj":"주문 시간: ",
     "yhl":"이익: ",
     "syts":"남은 일수: ",
     "sh":"구원",
     "syl":"수익률",
     "bz":"이름",
     "dl":"환율",
     "tgts":"개최일: ",
     "tgsl":"호스팅 수량",
     "qsrtgsl":"호스팅 수량을 입력하세요",
     "dbxe":"단일 거래 한도",
     "ljtg":"지금 호스트하세요",
     "zztg":"보관된 자금",
     "yjjrsy":"오늘 예상 수입",
     "ljsy":"누적 수입",
     "tgzdd":"구금 명령",
     "ljzc":"지금 환승",
     "gz":"규칙",
     "cpzq":"제품주기",
     "gm":"구입하다",
     "ts":"중요한",
     "shts":"환매 운영 중이며, 만기 전에 환매할 경우 5% 손실을 입게 됩니다. 사용하시겠습니까?",
     "xgcs":"구매 제한 횟수",
   },
   "dk":{
     "dk":"대출",
     "dkzh":"대출계좌",
     "yzsf":"본인인증하고 더 많은 대출금액 받아가세요!",
     "ksyz":"인증 시작",
     "wxj":"빌리고싶다...",
     "dkqx":"대출 기간(일): ",
     "mrll":"일일 이자율: ",
     "lxze":"총 이자: ",
     "dkts":"3일 동안 대출금에 이자가 필요하지 않으며, 그 이후에는 이자를 지불할 수 있습니다.",
     "xzj":"지금 대출",
     "wyydbzx":"동의하다",
     "dkfwxy":"<대출 서비스 계약>",
     "dkfwxy2":"대출 서비스 계약",
     "dkysxy":"대출 개인정보 보호 계약",
     "dkjl":"대출 내역",
     "hth":"아니요.",
     "yfk":"지급됨",
     "lx":"관심: ",
     "zhke":"총 상환액: ",
     "znj":"연체료: ",
     "znjl":"연체료율: ",
     "yqts":"연체 일수: ",
     "qhk":"상환하다",
     "tpsc":"신용대출(이미지 업로드)",
     "fwxx":"주택정보",
     "srzm":"소득 증명(고용 관계)",
     "yhmx":"은행 계좌 정보",
     "zjz":"증명사진",
     "ljdk":"지금 대출",
     "xm":"이름",
     "ndxm":"당신의 이름",
     "qsrndxm":"당신의 이름을 입력",
     "gj":"국가",
     "ndgj":"귀하의 국가",
     "qsrndgj":"국가를 입력하세요",
     "dz":"주소",
     "nddz":"주소",
     "qsrnddz":"주소를 입력하세요",
     "csrq":"생일",
     "ndcsrq":"귀하의 생년월일",
     "qsrndcsrq":"생년월일을 입력하세요",
     "dhhm":"전화 번호",
     "nddhhm":"전화 번호",
     "qsrnddhhm":"전화번호를 입력하세요",
     "zj":"서류",
     "sfzm":"긍정적인 정체성",
     "qscsfzm":"당신의 정체성의 긍정적인 면을 업로드하세요",
     "sffm":"정체성의 반대",
     "qscsffm":"신분증 뒷면을 업로드하세요.",
     "ddqr":"주문 확인",
     "jk":"대출: ",
     "dkqx2":"대출 기간: ",
     "qrxd":"주문 확인",
     "yhkxq":"상환 기한 내역",
     "hkqr":"상환확인",
     "yhk":"상환 기한: ",
     "jksj":"대출 시간: ",
     "ljhk":"즉시 갚으세요",
   },
   "jy":{
     "rq":"날짜",
     "qqjy":"옵션 기록",
     "hyjy":"계약",
     "qqhy":"옵션",
     "dqwt":"보류 중",
     'wtz':"위탁 중",
     "hyjl":"계약기록",
     "shou":"많이",
     "dk":"영형: ",
     "zhjg":"최신: ",
     "jyfy":"거래 수수료: ",
     "kfsj":"개관 시간: ",
     "gg":"지렛대: ",
     "pl":"일괄: ",
     "kpj":"개장 가격: ",
     "yk":"이익과 손실: ",
     "cd":"주문 취소",
     "jsj":"결제 가격: ",
     "fx":"방향: ",
     "jgsj":"배달 시간: ",
     "gb":"닫다",
     "jxxd":"계속하다",
     "xj":"한계: ",
     "gm":"구입하다: ",
     "sl":"수량",
     "fy":"비용: ",
     "tzbzj":"여백 조정",
     "zyzs":"이익을 얻고 손실을 막으세요",
     "pc":"포지션 마감",
     "mr":"구입하다",
     "zjbzj":"마진 증가",
     "jsbzj":"마진 감소",
     "yxhy":"계약 거래: ",
     "cc":"직위: ",
     "cc2":"위치",
     "cwbzk":"포지션 마진: ",
     "zdzjbzj":"마진 최대 증가: ",
     "zjbzj2":"마진 증가: ",
     "qsrzbzj":"보증금을 입력해 주세요",
     "yxhy2":"빈번한",
     "kp":"평평할 수 있다",
     "zhang":"열려 있는",
     "xj2":"한계",
     "zy":"이익을 얻으세요",
     "zs":"손실 중지",
     "ssjyzl":"거래 유형 검색",
     "ddb":"주문서",
     "di":"엘: ",
     "gao":"시간: ",
     "gb2":"씨: ",
     "fz":"분",
     "mai":"구입: ",
     "zhang2":"증가",
     "tie":"떨어지다",
     "sy":"반품",
     "kz":"강세",
     "kt":"약세",
     "bndy":"다음보다 낮을 수 없습니다.",
     "sxbzj":"필수 보증금: ",
     "ky":"사용 가능: ",
     "sj":"시장",
     "mc":"팔다",
     "zxtzsl":"최소 수량",
     "min":"최소 금액",
     "max":"최대 금액",
     "yebz":"잔액 불충분",
     "ddz":"대기 중",
     "wtzl":"커미션 금액: ",
     "wtjg":"수수료 가격: ",
     "ycd":"취소 된",
     "lswt":"역사적인",
     "qsrzyjg":"이익 실현 가격을 입력하세요.",
     "qsrzsjg":"손실정지가격을 입력해주세요",
     "ccsl":"직책 수: ",
     "ccjg":"포지션 가격: ",
     "ggbs":"여러 가지 활용: ",
     "zy2":"이익을 얻으세요: ",
     "zs2":"손실 중지: ",
     "zje":"일시불: ",
     "ss":"많이: ",
     "kcjg":"개장 가격: ",
     "bzjl":"마진율: ",
     "lscc":"역사적 위치",
     "gmj":"구매 가격: ",
     "guadan":"대기 중인 주문",
     "dqjg":"현재 가격: ",
     "gdjg":"보류 중인 주문 가격: ",
     "pcjg":"종가: ",
     "ccsj":"위치 유지 시간: ",
     "gdsj":"주문 보류 시간: ",
     "pcsj":"마감 시간: ",
     "fdjyk":"변동순이익 및 손실",
     "pcsl":"마감 수량",
     "qrpc":"포지션 청산 확인",
     "ypc":"포지션 폐쇄",
     "ss2":"많이",
     "qsrss":"로트 크기를 입력하세요",
   },
   "gjrz":{
     "sfyz":"KYC 인증",
     "t1":"1. 8M보다 작은 JPG, JPEG 또는 PNG 형식의 사진을 지원합니다.",
     "t2":"2. 증명사진은 선명해야 하며, 수정이나 차단이 불가합니다. 초상화, 신분증 번호, 이름이 선명하게 보여야 합니다.",
     "t3":"3. 사진은 모자를 쓰지 않은 채 촬영되어야 하며, 화장을 하지 않는 것이 좋습니다. 문서를 들고 있는 사람의 얼굴 생김새가 선명하게 보여야 하며, 팔 전체가 노출되어야 합니다.",
     "t4":"좋아요",
     "bh":"거부하다",
     "shz":"검토중",
     "shtg":"시험 합격",
     "nyrzcg":"성공적으로 인증되었습니다",
     "sczjz":"신분증 사진 업로드",
     "sczjzmz":"신분증의 앞면 사진을 업로드하세요.",
     "sczjbmz":"신분증 뒷면 사진 업로드",
     "scgrqmz":"손에 들고 있는 신분증 사진을 업로드하세요.",
     "gjlb":"국가 목록",
     "qxzgjlb":"국가/지역을 선택하세요",
     "zsxm":"실명",
     "qsrzsxm":"실명을 입력하세요",
     "zjlx":"인증서 유형: ",
     "zjhm":"ID 번호",
     "qsrzjhm":"귀하의 ID 번호를 입력하세요",
     "khh":"계좌 개설 은행",
     "qsrkhh":"계좌 개설 은행을 입력하세요",
     "yhkh":"은행 카드 번호",
     "qsryhkh":"은행 카드 번호를 입력하세요",
   },
   "status":{
     "statusText":['실패','검토중','성공'],
   },
   "download":{
     "t1":"언제 어디서나 모바일 트레이딩",
     "xz":"다운로드",
   },
   "langNew":{
     "szhb": "암호화폐",
     "gjs": "금속",
     "ny": "에너지",
     "yy": "조잡한",
     "jy": "거래",
     "jmhb": "암호화폐",
     "yxhy": "영구 계약",
     "gdjy": "미결 주문",
     "khh": "계좌 개설",
     "qsrkhh": "은행에 들어가주세요",
     "yhkh": "은행 계좌",
     "qsryhkh": "은행 계좌 번호를 입력해 주십시오",
     "mnzh":"데모 계정",
     "zjjypt":"최고의 거래 플랫폼",
     "brjmzndxq":"이 소프트웨어는 최고의 기술 전문성으로 귀하의 모든 요구를 충족시킵니다.",
     "jx":"계속하다",
     "yssm":"개인 정보 보호 정책",
     "fxqzc":"자금세탁 방지 정책",
     "jgxkz":"규제 라이센스",
     "ckgd":"더",
     "gd":"더",
     "dd":"주문하다",
     "ckdd":"주문 보기",
     "yxdd":"빈번한",
     "qqdd":"옵션",
     "hand":"난 많이= ",
     "lxwm":"문의하기",
     "tpfzl":"여기에 이미지를 배치하거나 ",
     "liulang":"검색",
     "zctpgs":"지원: JPG, JPEG2000, PNG",
     "ysr":"월 소득",
     "ndysr":"월 소득",
     "qsrndysr":"월 소득을 입력하세요.",
     "yqtzje":"투자예정금액",
     "qsrtzje":"예상 투자 금액을 입력하세요.",
     "zszh":"실계좌",
     "qdl": "로그인 해주세요",
     "zx": "즐겨찾기",
     "hkdz":"상환 주소",
     "dkje":"대출 금액: ",
     "zlx":"총이자: ",
     "hkze":"총상환: ",
     "qcz":"입금하러가기",
     "yebz":"잔액이 부족합니다. 충전해주세요.",
     "dhje":"상환할 금액：",
     "hkjl":"상환명령：",
     "hkje":"반환：",
     "kyye":"균형：",
     "qb": '모두',
     "lmc": "체인명：",
     "search": "찾다",
     "mrjg":"가격",
     "lxkf":"연락하다",
     "wyj":"손해금",
     "yxsj":"진행 중：",
     "jssj":"마치다：",
     "hksj":"반환：",
     "sysj":"남은 시간：",
     "jkqx":"남은 시간：",
     "yq":"연체：",
     "qqss":"귀하의 옵션 거래 주문이 만료되었으며 귀하의 손실은 다음과 같습니다",
     "qqlr":"귀하의 옵션 거래 주문이 만료되었으며 귀하의 이익은 다음과 같습니다",
     "bz":"통화",
     "dzje":"받은 금액",
     "lxyxzc":"이메일 지원",
   },
   "langNew9":{
   "dzje":"거래 상품의 시장 동향",
   "lxyxzc":"디지털 거래 여정을 시작하세요",
   "text1":"계정을 만들어 시작하세요",
   "text2":"친구를 초대하여 FXSFC에 가입하고 함께 플레이하세요",
   "text3":"계정에 충전하세요",
   "text4":"여러 통화 충전을 지원하여 빠르게 거래를 시작할 수 있습니다",
   "text5":"거래를 시작하세요",
   "text6":"다양한 고품질 거래 쌍을 제공하고 FXSFC에서 즐겁게 거래하세요",
    "text7":"친구를 초대하여 USDT를 획득하세요",
    "text8":"친구를 초대하여 쉽게 USDT를 획득하세요",
    "text9":"대출 기능이 온라인 상태입니다",
    "text10":"돈이 없을 때 대출을 신청할 수 있으며, 대출은 빠르면 당일에 발급됩니다",
   "text11":"모든 자산 거래",
   "text12":"외환, 암호화폐, 선물, ETF 등",
   },
   "bank":{
     "text1":"가장 신뢰할 수 있는 재무 관리 플랫폼",
     "text2":"실시간 뉴스 알림",
     "text3":"금융산업에 대한 실시간 정보를 이해하세요.",
     "text4":"이해하기 시작하다",
     "text5":"뉴스 플래시",
     "text6":"은행 선택",
     "text7":"은행 카드",
     "text8":"양...",
     "text9":"은행 카드 추가",
     "text10":"은행 계좌",
     "text11":"은행계좌를 입력해주세요",
     "text12":"카드 아이디",
     "text13":"카드번호 아이디를 입력해주세요",
     "text14":"은행 국제 코드",
     "text15":"은행 국제 코드",
     "text16":"전화번호를 입력해주세요",
     "text17":"다음에 추가",
     "text18":"은행 카드 삭제",
     "text19":"실제 도착",
     "text20":"인출 정보",
     "text21":"은행 카드 선택",
     "text22":"참고",
     "text23":"최소 인출 금액:",
     "text24":"최소 인출 금액보다 적은 금액은 인출이 허용되지 않습니다",
     "text25":"• 자금의 안전을 보장하기 위해 계정 보안 정책이 변경되거나 비밀번호가 변경되면 인출을 수동으로 검토합니다. 직원이 전화 또는 이메일로 연락할 때까지 기다려 주십시오.",
     "text26":"• 정보가 변조되거나 유출되는 것을 방지하기 위해 컴퓨터와 브라우저가 안전한지 확인하십시오.",
     "text27":"• 인출하는 USD의 경우, 각 작업은 인출 페이지에 표시된 총 자산 금액이 해당 인출 금액만큼 감소함을 의미합니다. 금액.",
     "text28":"인출 기록",
     "text29":"법정 화폐 유형",
   }
   // "langNew2":{
   //   "sy":"홈페이지",
   //   "sc":"시장",
   //   "sclb":"시장 목록",
   //   "jy":"거래",
   //   "zh":"계정",
   //   "db":"대출",
   //   "zchm":"등록 번호",
   //   "cp":"제품",
   //   "tzjd":"투자대출",
   //   "zxzc":"온라인 지원",
   //   "xd":"주문하다",
   //   "zzjptgmnr":"미래에 투자하세요.공정하고 개방적인 금융 시스템에서 포트폴리오를 성장시키세요.",
   //   "yy":"앱",
   //   "pqnr":"기존의 틀에서 벗어나 정밀한 재무관리 도구를 제공하는 모바일뱅킹입니다.",
   //   "jiami":"암호화폐",
   //   "tgnr":"암호화폐를 사용하여 입금하면 추가 보안 계층을 확보하고 빠른 거래 처리를 보장할 수 있습니다.",
   //   "jyl":"24시간 거래량",
   //   "ssjmhb":"암호화폐 목록",
   //   "zchy":"등록 된 사용자들",
   //   "djxz":"다운로드하려면 클릭하세요",
   //   "azsc":"안드로이드 마켓",
   //   "pgsd":"애플 스토어",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/kr.js